import * as React from 'react';

import { Label, ILabelProps } from '../../../common/components/label';

const style = require('./index.css');

interface IOfferLabelsProps {
  offersList: Array<ILabelProps>;
}

export const OfferLabels = (props: IOfferLabelsProps) => (
  <div className={style['saved-search-labels']}>
    {props.offersList.map(({ text, textColor, backgroundColor }) =>
      <Label
        key={text}
        backgroundColor={backgroundColor}
        text={text}
        textColor={textColor}
      />)
    }
  </div>
);
